import { render, staticRenderFns } from "./addAnnouncement.vue?vue&type=template&id=5bc4d7d8&scoped=true"
import script from "./addAnnouncement.vue?vue&type=script&lang=js"
export * from "./addAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./addAnnouncement.vue?vue&type=style&index=0&id=5bc4d7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4d7d8",
  null
  
)

export default component.exports